import { ValidTextResponse } from "@/types/actions";

export const checkAdmin = (groups: string[]) => groups.includes("Admin");

export const formatTimestamp = (timestamp: string) => {
  // Backend timestamps may lack a timezone suffix (stored as UTC via
  // datetime.utcnow before the fix). Treat naive ISO strings as UTC so
  // the browser converts them to local time correctly.
  const hasTimezone = /Z|[+-]\d{2}:\d{2}$/.test(timestamp);
  const normalized = hasTimezone ? timestamp : timestamp + "Z";
  const date = new Date(normalized);
  return date.toLocaleString();
};

export const truncateText = (text: string, maxLength: number = 25) =>
  text.length <= maxLength ? text : text.slice(0, maxLength - 3) + "...";

export const formatUnits = (count: number, unit: string, pluralUnit?: string) =>
  count === 1 ? unit : pluralUnit ?? `${unit}s`;

// Generic validation for checking common requirements
export const validateText = (name: string): ValidTextResponse => {
  let message: string | undefined;

  if (name.trim().length === 0) {
    message = "Cannot be empty string.";
  } else if (name.match(/^[a-zA-Z0-9\-_'\s]*$/g) == null) {
    message =
      "Only alphanumeric characters, hyphens, apostrophes, underscores, and spaces are allowed.";
  }

  return { isValid: message == undefined, message };
};
